import { OPEN_PROFILE, CLOSE_PROFILE } from '../constants/index';
import { ProfileState, ProfileActions } from '../types/profileTypes'

const initialState: ProfileState = {
  isOpen: false
}

const profileReducer = (state = initialState, action: ProfileActions) => {
  // const payload = action.payload
  switch(action.type){

    case OPEN_PROFILE:
      return {
        ...state,
        isOpen: true,
      }

    case CLOSE_PROFILE:
      return {
        ...state,
        isOpen: false,
      }
    
    default: 
      return state
  }
}

export default profileReducer;